export const getModalV2Id = (state) => state.modalId;
